export default __webpack_public_path__ + "static/media/team-photo-2023.c071431e.jpg";